<template>
  <button
    type="button"
    class="relative block w-full cursor-pointer py-2.5 pr-5 text-left hover:bg-gray-100/60"
    @click="emit('open')"
  >
    <span class="absolute right-0 bottom-0 left-[34px] h-px bg-[#2d2d2d]/8" />

    <span class="flex h-5 items-center justify-between pl-[34px]">
      <span
        class="flex h-5 items-center rounded-[4px] px-1.5 text-[12px] leading-[15px] text-white"
        :class="LEVEL_BG[level]"
      >
        {{ LEVEL_LABEL[level] }}
      </span>
      <Pill variant="default" :icon="FlagIcon">Flagged</Pill>
    </span>

    <span class="relative mt-[3px] flex flex-col gap-y-2.5">
      <SortIcon
        class="absolute top-1/2 left-[34px] z-10 -mt-[7px] size-3.5 text-gray-800"
        aria-hidden="true"
      />
      <span class="flex items-center gap-x-3">
        <span class="size-[22px] shrink-0">
          <Thumbnail :type="material.type" :src="material.src" />
        </span>
        <span class="truncate text-[13px] leading-[18px] text-gray-900">
          {{ material.name }}
        </span>
      </span>
      <span class="flex items-center gap-x-3">
        <span class="size-[22px] shrink-0">
          <Thumbnail :type="fileTypeToThumbnail(findingFileType(finding))" />
        </span>
        <span class="truncate text-[13px] leading-[18px] text-gray-900">
          {{ findingTitle(finding) }}
        </span>
      </span>
    </span>
  </button>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { Pill, Thumbnail } from '@dacr/library'
import { FlagIcon, SortIcon } from '@dacr/icons'

import { ScoreLevel } from '@/shared/graphql/router/graphql'
import { fileTypeToThumbnail } from '@/shared/utils/thumbnail'

import {
  findingFileType,
  findingLevel,
  findingTitle,
  type Finding,
} from './findings'
import { checkedMaterial } from './material'
import type { CheckerResults } from './results'

const props = defineProps<{ finding: Finding; results: CheckerResults }>()

const emit = defineEmits<{ open: [] }>()

const LEVEL_LABEL: Record<ScoreLevel, string> = {
  [ScoreLevel.Low]: 'Low risk',
  [ScoreLevel.Medium]: 'Medium risk',
  [ScoreLevel.High]: 'High risk',
}

const LEVEL_BG: Record<ScoreLevel, string> = {
  [ScoreLevel.Low]: 'bg-gray-300',
  [ScoreLevel.Medium]: 'bg-yellow-500',
  [ScoreLevel.High]: 'bg-red-500',
}

const level = computed(() => findingLevel(props.finding))
const material = computed(() => checkedMaterial(props.results))
</script>
